import React from "react";
import { Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useDarkMode } from "src/context/DarkModeContext";
import { TableModel } from "src/data/models/table-models/TableModel";

const { Title } = Typography;

interface GrammarComparisonTableProps {
    tableData: TableModel;
    chunkSize?: number; // how many columns to show per chunk
}

const GrammarComparisonTable: React.FC<GrammarComparisonTableProps> = ({
    tableData,
    chunkSize = 3, // default to 3 columns per chunk
}) => {
    const { isDarkMode } = useDarkMode();

    if (!tableData || tableData.rows.length === 0 || tableData.headers.length === 0) {
        return null;
    }

    const totalCols = tableData.headers.length;
    const chunks = [];

    for (let i = 0; i < totalCols; i += chunkSize) {
        const headerChunk = tableData.headers.slice(i, i + chunkSize);
        const columns: ColumnsType<any> = headerChunk.map((header, index) => ({
            title: header,
            dataIndex: `col${index}`,
            key: `col${index}`,
            align: "center",
        }));

        const dataSource = tableData.rows.map((row, rowIndex) => {
            const rowData: any = { key: rowIndex };
            row.slice(i, i + chunkSize).forEach((cell, cellIndex) => {
                rowData[`col${cellIndex}`] = cell;
            });
            return rowData;
        });

        chunks.push(
            <div key={i} style={{ marginBottom: 32 }}>
                <Table
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    bordered
                    size="middle"
                />
            </div>
        );
    }

    return (
        <div style={{
            margin: "0px auto",
            maxWidth: "850px"
        }}>
            <Title
                level={4}
                style={{
                    color: isDarkMode ? "white" : "black",
                    textAlign: "center",
                    marginBottom: 16,
                }}
            >
                {tableData.title}
            </Title>
            {chunks}
        </div>
    );
};

export default GrammarComparisonTable;
